<template>
  <div>
    <div class="page-container">
      <md-app md-waterfall md-mode="fixed" style="min-height: 100vh;">
        <md-app-toolbar class="md-primary">
          <div class="d-flex order-lg-2">
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
            <div style="margin-left: auto !important;">
            <h3 class="title">UFA Easy888</h3>
            <div style="justify-content: center; display: flex; margin-top: 8px;">
              <span style="font-size: 16px; color: yellow;">{{code}}</span>
            </div>
            </div>
          <div class="d-flex order-lg-2 ml-auto">
              <div class="dropdown">
                <a
                  href="#"
                  class="nav-link pr-0 leading-none"
                  data-toggle="dropdown"
                >
                  <span
                    class="avatar"
                    id="avatar"
                    :style="{ 'background-image': `url(${pictureUrl})` }"
                  ></span>
                </a>
              </div>
            </div>
        </md-app-toolbar>
        <md-app-content style="margin-bottom: 40px;">
          <table cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                    <td align="center">
                        <h2
                            style="font-size: 18px; font-weight: 700; color: #FFFFFF; margin: 0; padding: 12px 0 6px 0;">
                            TOP CONTRIBUTORS
                        </h2>
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <table cellspacing="0" cellpadding="0" border="0" width="100%" style="font-size: 15px; color: #FFF; font-weight: 800; margin: 16px 0 0 0;">
                            <tr>
                               <td align="center" colspan="2">
                                    <img src="../assets/images/1.png" width="80" height="80">
                                </td>
                            </tr>
                            <tr>
                                <td align="center" height="24" colspan="2">
                                    <div style="color: #FFFFFF;text-shadow: 0 -1px 4px #FFF, 0 -2px 10px #ff0, 0 -10px 20px #ff8000, 0 -18px 40px #F00;" v-if="this.first">{{this.first.toUpperCase()}} <span v-if="this.firstmine">🥳</span></div>
                                </td>
                            </tr>
                            <tr>
                                <td align="center">
                                    <img src="../assets/images/2.png" width="80" height="80">
                                </td>
                                <td align="center">
                                    <img src="../assets/images/3.png" width="80" height="80">
                                </td>
                            </tr>
                            <tr>
                                <td align="center" height="24">
                                   <div style="color: #FFFFFF;text-shadow: 0 -1px 4px #FFF, 0 -2px 10px #ff0, 0 -10px 20px #ff8000, 0 -18px 40px #F00;" v-if="this.second">{{this.second.toUpperCase()}} <span v-if="this.secondmine">🥳</span></div>
                                </td>
                                <td align="center" height="24">
                                    <div style="color: #FFFFFF;text-shadow: 0 -1px 4px #FFF, 0 -2px 10px #ff0, 0 -10px 20px #ff8000, 0 -18px 40px #F00;" v-if="this.third">{{this.third.toUpperCase()}} <span v-if="this.thirdmine">🥳</span></div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td height="14"></td>
                </tr>
                <tr v-for="(item,index) in history"  :key="index">
                    <td align="center">
                        <table cellspacing="0" cellpadding="0" border="0" width="90%" style="margin: 12px 0 0 0; box-shadow: 0 3px 6px #d8d8d9; border-radius: 4px; overflow: hidden;">
                            <tr>
                                <td align="left" bgcolor="#FFFFFF">
                                    <table cellspacing="0" cellpadding="0" border="0" width="100%">
                                        <tr>
                                            <td align="left" bgcolor="#FFFFFF" style="padding: 16px 16px 16px 16px; color: #7E7E7E; font-size: 16px; font-weight: 700;">
                                                {{item.no}}.
                                            </td>
                                            <td align="left" bgcolor="#FFFFFF" width="150">
                                                <p style="font-size: 15px; color: #050505; font-weight:850; margin:0;">{{item.code}}&nbsp;<span v-if="item.mine">🥳</span></p>
                                            </td>
                                            <td align="right" bgcolor="#FFFFFF" style="font-size:18px; color: #3FD1AA; font-weight: 850; padding: 0 6px 0 0;padding-right: 10px;width:100px;">
                                                +50
                                                <img src="https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media" width="36" height="36">
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td height="24"></td>
                </tr>

            </table>
        </md-app-content>
      </md-app>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import router from "./../router";
import moment from "moment-timezone";
import liffService from "@/services/liff";
export default {
  name: 'Ranking',
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      menuVisible: false,
      pictureUrl:'',
      history:[],
      code:"",
      first:'',
      second:'',
      third:'',
      unsub:null,
      firstmine:false,
      secondmine:false,
      thirdmine:false,
      rank:0,
      full:false,
      sendmessage:false,
    }
  },
  methods: {
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        this.getDatatHistory(this.userId);
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
          router.replace("/register");
        } else {
          let user = {};
          for (const x in users) {
            user = users[x];
          }
          this.code = user.code;
        }
      }
    },
    async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": text,
          },
      ]);
	  },
    getDatatHistory(userId){
      //ครั้งหน้าลบ 00 วินาทีออก
      this.unsub = firebase.firestore().collection('krungsri').where('date', '>=', '2021-11-11 18:00').where('type','==','ฝาก').orderBy('date','asc').limit(400).onSnapshot((querySnapshot) => {
          const history = [];
          let i = 1;
          const checkcode = [];
          querySnapshot.forEach((doc) => {
              if(doc.data().user && checkcode[doc.data().user.code] === undefined){
                  if(Number(doc.data().qty.toString().replace(',','')) >= 300 && i <= 20){
                    checkcode[doc.data().user.code] = true;
                    const data = doc.data();
                    data.key = doc.id;
                    data.no = i;
                    data.code = doc.data().user.code;
                    if(data.userId === userId){
                      data.mine = true;
                      this.rank = i;
                    }
                    if(i == 1){
                        this.first = doc.data().user.code;
                        if(data.mine)
                        this.firstmine = true;
                    }else if(i == 2){
                        this.second = doc.data().user.code;
                        if(data.mine)
                        this.secondmine = true;
                    }else if(i == 3){
                        this.third = doc.data().user.code;
                        if(data.mine)
                        this.thirdmine = true;
                    }else{
                        history.push(data);
                    }
                    i++;
                  }
              }
          });
          if(querySnapshot.size == 0){
              this.first = 'XXXXXXXX';
              this.second = 'XXXXXXXX';
              this.third = 'XXXXXXXX';
              history.push({no:4,code:'XXXXXXXX'});
              history.push({no:5,code:'XXXXXXXX'});
              history.push({no:6,code:'XXXXXXXX'});
              history.push({no:7,code:'XXXXXXXX'});
              history.push({no:8,code:'XXXXXXXX'});
              history.push({no:9,code:'XXXXXXXX'});
              history.push({no:10,code:'XXXXXXX'});
              history.push({no:11,code:'XXXXXXX'});
              history.push({no:12,code:'XXXXXXX'});
              history.push({no:13,code:'XXXXXXX'});
              history.push({no:14,code:'XXXXXXX'});
              history.push({no:15,code:'XXXXXXX'});
              history.push({no:16,code:'XXXXXXX'});
              history.push({no:17,code:'XXXXXXX'});
              history.push({no:18,code:'XXXXXXX'});
              history.push({no:19,code:'XXXXXXX'});
              history.push({no:20,code:'XXXXXXX'});
          }
          this.history = history;
          console.log(i);
          console.log(this.first);

          if(i > 20 && this.first !== 'XXXXXXXX') this.full = true;
          if(!this.sendmessage){
            if(this.rank > 0) {
              let emoji = '🏅';
              if(this.rank == 1){
                emoji = '🥇';
              }else if(this.rank == 2){
                emoji = '🥈';
              }else if(this.rank == 3){
                emoji = '🥉';
              }
              this.sendMessageLine2(emoji+' ว้าวว ยินดีด้วยค่ะคุณอยู่อันดับที่ '+this.rank+' อย่างไม่เป็นทางการ รอสรุปหลังเกมส์จบนะคะ 😍😍');
            }else{
              //this.sendMessageLine2('😱😱 เสียใจด้วยนะคะคุณไม่ทันคนอื่นเขา ไม่เป็นไรค่ะรอโอกาสครั้งหน้านะคะ 😘😘');
              if(moment().tz("Asia/Bangkok").format("YYYYMMDDHHmmss") >= 20211111180000){
                if(!this.full){
                  this.sendMessageLine2('💥💥 สู้ๆ ค่ะพี่ ยังทันค่ะพี่รีบโอนมาเลยนะคะ 💥💥');
                }else{
                  this.sendMessageLine2('😱😱 เสียใจด้วยนะคะคุณไม่ทันคนอื่นเขา ไม่เป็นไรค่ะรอวันที่ 12 เดือน 12 นะคะ 😘😘');
                }
              }else{
                this.sendMessageLine2('🥁🥁  รอเวลาเริ่มเกมส์นะคะ 🥁🥁');
              }
            }
            this.sendmessage = true;
          }
      });
      //this.sendMessageLine2('กิจกรรมมาวันที่ 5 พฤษภาคมนะคะ 😘😘');
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-app {
    height: 500px;
    border: 1px solid rgba(#000, .12);
  }
  .md-toolbar.md-theme-default.md-primary {
     background-color: #000;
  }
  .md-content.md-theme-default {
    background-color: #000;
  }
   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-card.md-theme-default {
    background-color: #000;
    background-color: var(--md-theme-default-background, #000);
  }
</style>
<style>
/* CLIENT-SPECIFIC STYLES */
             body,
             table,
             td,
             a {
                 -webkit-text-size-adjust: 100%;
                 -ms-text-size-adjust: 100%;
             }
     
             table,
             td {
                 mso-table-lspace: 0pt;
                 mso-table-rspace: 0pt;
             }
     
             img {
                 -ms-interpolation-mode: bicubic;
             }
     
             /* RESET STYLES */
             img {
                 border: 0;
                 height: auto;
                 line-height: 100%;
                 outline: none;
                 text-decoration: none;
             }
     
             table {
                 border-collapse: collapse !important;
             }
     
             body {
                 height: 100% !important;
                 margin: 0 !important;
                 padding: 0 !important;
                 width: 100% !important;
             }
     
             /* iOS BLUE LINKS */
             a[x-apple-data-detectors] {
                 color: inherit !important;
                 text-decoration: none !important;
                 font-size: inherit !important;
                 font-family: inherit !important;
                 font-weight: inherit !important;
                 line-height: inherit !important;
             }
     
             /* MOBILE STYLES */
             @media screen and (max-width: 600px) {
                 .img-max {
                     width: 100% !important;
                     max-width: 100% !important;
                     height: auto !important;
                 }
     
                 .max-width {
                     max-width: 100% !important;
                 }
     
                 .mobile-wrapper {
                     width: 85% !important;
                     max-width: 85% !important;
                 }
     
                 .mobile-padding {
                     padding-left: 5% !important;
                     padding-right: 5% !important;
                 }
             }
     
             /* ANDROID CENTER FIX */
             div[style*="margin: 16px 0;"] {
                 margin: 0 !important;
             }

</style>